/**
 * Site-wide schema.org entity definitions.
 *
 * AI assistants and search engines resolve "what is PrecisionTrader" from
 * structured data, not marketing copy. The homepage is the canonical entity
 * page, so it carries the Organization / WebSite / SoftwareApplication graph.
 *
 * Prices are deliberately omitted: /pricing and /pricing.md are the single
 * source of truth, and a hardcoded amount here would silently go stale.
 */
import { SITE_URL } from '../components/Seo';

const PRODUCT_DESCRIPTION =
  'PrecisionTrader enforces configurable trading rules in real time, blocking trades that break your plan. It adds bracket orders, automatic position sizing, auto-filled trade journals, and performance analytics across connected brokerage accounts.';

export const organizationSchema = {
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'PrecisionTrader',
  url: SITE_URL,
  description: PRODUCT_DESCRIPTION,
  logo: {
    '@type': 'ImageObject',
    url: `${SITE_URL}/logo.png`,
  },
};

export const websiteSchema = {
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  name: 'PrecisionTrader',
  url: SITE_URL,
  publisher: { '@id': `${SITE_URL}/#organization` },
};

export const softwareApplicationSchema = {
  '@type': 'SoftwareApplication',
  '@id': `${SITE_URL}/#software`,
  name: 'PrecisionTrader',
  url: SITE_URL,
  applicationCategory: 'FinanceApplication',
  applicationSubCategory: 'Trading risk management and execution workflow software',
  operatingSystem: 'Web browser',
  description: PRODUCT_DESCRIPTION,
  publisher: { '@id': `${SITE_URL}/#organization` },
  featureList: [
    'Real-time trading rule enforcement',
    'Bracket orders with multiple take-profit targets',
    'Automatic risk-based position sizing',
    'Auto-filled trade journals after closed positions',
    'Performance and account health analytics',
    'PrecisionAI trade review chat',
    'Multi-broker connectivity through a unified integration layer',
  ],
};

export const homePageSchema = {
  '@context': 'https://schema.org',
  '@graph': [organizationSchema, websiteSchema, softwareApplicationSchema],
};
